import { Badge } from '@/components/ui/badge';
import { SortableHeader } from '@/components/ui/data-table';

import { formatDate } from '@/lib/date';

import { getEventBadgeProps, humanizeLabel } from '../audit-log.utils';

import { AuditLogMessage } from './audit-log-message';

import type { AuditLog } from '@/types/audit-log.type';
import type { ColumnDef } from '@tanstack/react-table';

export const getColumns = (): ColumnDef<AuditLog>[] => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) => <span className="font-medium">{getValue() as number}</span>,
  },
  {
    id: 'type',
    accessorKey: 'type',
    header: ({ column }) => <SortableHeader label="Event" column={column} />,
    cell: ({ getValue }) => {
      const type = getValue() as string;
      const eventBadge = getEventBadgeProps(type);
      return (
        <Badge variant={eventBadge.variant} className={eventBadge.className}>
          {humanizeLabel(type)}
        </Badge>
      );
    },
  },
  {
    id: 'module',
    accessorKey: 'module',
    header: ({ column }) => <SortableHeader label="Module" column={column} />,
    cell: ({ getValue }) => <Badge variant="secondary">{getValue() as string}</Badge>,
  },
  {
    id: 'user_email',
    accessorKey: 'user_email',
    header: ({ column }) => <SortableHeader label="User" column={column} />,
    cell: ({ getValue }) => (
      <span className="text-sm text-muted-foreground">{(getValue() as string) || '-'}</span>
    ),
  },
  {
    id: 'message',
    header: 'Details',
    cell: ({ row }) => <AuditLogMessage log={row.original} />,
  },
  {
    id: 'created_at',
    accessorKey: 'created_at',
    header: ({ column }) => <SortableHeader label="Created at" column={column} />,
    cell: ({ getValue }) => (
      <span className="text-sm text-muted-foreground">{formatDate(getValue() as string)}</span>
    ),
  },
];
